{
  "hero": {
    "title": "Concepție. Design. Implementare."
  },
  "cta-contact": "Ai un proiect în minte? Contactează-mă!",
  "hook": "Proiectarea poveștilor care conectează — prin video, fotografie și experiențe digitale.",
  "industry": {
    "title": "Soluții media pentru industria ta",
    "options": {
      "ecommerce": "Afaceri E-commerce",
      "restaurants": "Restaurante și Cafenele",
      "retail": "Magazine de retail",
      "salons": "Salonuri și Spa-uri",
      "fitness": "Centre de fitness și săli de sport",
      "realestate": "Agenții imobiliare",
      "professional": "Servicii profesionale",
      "homeservices": "Servicii pentru casă"
    }
  },
  "benefits": {
    "title": "10 motive pentru care conținutul video este bun pentru afacerea ta:",
    "items": {
      "1": {
        "title": "1. Crește angajamentul:",
        "text": "Videoclipurile captează atenția mai rapid decât orice alt mediu, crescând angajamentul pe site-ul tău și pe platformele de social media."
      },
      "2": {
        "title": "2. Spune povestea ta:",
        "text": "Prezintă identitatea unică, valorile și produsele brandului tău într-un mod convingător și vizual care rezonează cu publicul tău."
      },
      "3": {
        "title": "3. Crește conversiile:",
        "text": "Un videoclip bine realizat poate genera mai mulți lead-uri și vânzări prin explicarea clară a ofertelor tale și construirea încrederii cu clienții potențiali."
      },
      "4": {
        "title": "4. Extinde acoperirea:",
        "text": "Conținutul video este foarte partajabil, ajutând mesajul tău să ajungă la un public mai larg pe multiple platforme."
      },
      "5": {
        "title": "5. Îmbunătățește SEO:",
        "text": "Videoclipurile îmbunătățesc pozițiile în motoarele de căutare prin creșterea timpului petrecut pe site-ul tău și generarea mai multui trafic organic."
      },
      "6": {
        "title": "6. Simplifică idei complexe:",
        "text": "Folosește animații sau videoclipuri explicative pentru a face conceptele intricate ușor de înțeles pentru clienții tăi."
      },
      "7": {
        "title": "7. Întărește amintirea brandului:",
        "text": "Oamenii sunt mai probabil să-și amintească brandul tău după ce văd un videoclip comparativ cu citirea doar a textului."
      },
      "8": {
        "title": "8. Construiește conexiuni emoționale:",
        "text": "Storytelling-ul video creează conexiuni mai profunde cu publicul tău, promovând loialitatea și încrederea."
      },
      "9": {
        "title": "9. Adaptează-te la tendințele moderne:",
        "text": "Cu video-ul fiind formatul preferat de conținut pentru consumatori, rămânerea competitivă înseamnă adoptarea acestui mediu puternic."
      },
      "10": {
        "title": "10. Demonstrează profesionalism:",
        "text": "Producția video de înaltă calitate reflectă angajamentul companiei tale pentru excelență și atenție la detalii."
      }
    }
  },
  "services": {
    "title": "Servicii",
    "subtitle": "Per proiect sau abonament",
    "tagline": "Alege flexibilitatea care se potrivește nevoilor tale!",
    "description": "Cu Serviciile Per Proiect, obții o soluție personalizată pentru producția video la cerere, perfectă pentru prezentări, campanii promoționale sau evenimente speciale. Dacă cauți suport constant și continuu, Abonamentul Lunar oferă conținut video regulat și de înaltă calitate pentru a menține brandul tău proaspăt și atractiv pe toate platformele. Ambele opțiuni includ ghidare profesională, storytelling creativ și optimizare pentru publicul modern.",
    "cta": "Ia legătura"
  },
  "gear": {
    "title": "Folosesc echipament profesional",
    "items": [
      "Panasonic GH7",
      "Olympus EM-III",
      "Elgato prompter",
      "Peak Design",
      "Rode",
      "și altele"
    ]
  },
  "software": {
    "title": "Folosesc software profesional"
  },
  "comparison": {
    "title": "Modul vechi",
    "titleKhromatik": "Modul Khromatik",
    "items": [
      {
        "old": "Angajarea a 3 freelanceri diferiți care nu vorbesc între ei.",
        "khromatik": "Un partener care înțelege codul, design-ul și obiectivul."
      },
      {
        "old": "Site frumos plin cu fotografii stock generice.",
        "khromatik": "Conținut personalizat filmat specific pentru layout-ul și utilizatorii tăi."
      },
      {
        "old": "Designeri juniori care învață pe bugetul tău.",
        "khromatik": "20 de ani de experiență aplicați pe fiecare pixel și fiecare cadru."
      }
    ]
  }
}

